import Api from '@/axios/api';

class InventoryApiService {
  // ─── Constants ──────────────────────────────────────────────────────────────

  static BASE_URL = '/customer/purchased-inventory';

  // ─── Inventory ──────────────────────────────────────────────────────────────

  getList(params) {
    return Api.get(InventoryApiService.BASE_URL, { params });
  }

  getNextPage(params) {
    return Api.get(InventoryApiService.BASE_URL, { params });
  }

  getRefillOptions(itemId) {
    return Api.get(`${InventoryApiService.BASE_URL}/item/${itemId}/refill-options`);
  }

  calculateRefillCost(itemId, qty) {
    return Api.post(`${InventoryApiService.BASE_URL}/item/${itemId}/refill-calculate-cost`, {
      items: [{ item_id: itemId, qty }],
    });
  }

  // ─── Permissions ────────────────────────────────────────────────────────────

  getPermissions(search = null) {
    return Api.get(`${InventoryApiService.BASE_URL}/customer-group/permissions`, {
      params: { query: search },
    });
  }

  // ─── Product settings ────────────────────────────────────────────────────────

  disableKitWhenOOS(itemId, value) {
    return Api.post(`${InventoryApiService.BASE_URL}/item/${itemId}/product-settings`, {
      disable_when_child_product_out_of_stock: value,
    });
  }

  saveSettings(itemId, data) {
    return Api.patch(`${InventoryApiService.BASE_URL}/item/${itemId}`, data);
  }

  // ─── Low qty alert ───────────────────────────────────────────────────────────

  saveLowQtyAlert(itemId, { enabled, value }) {
    return Api.patch(`${InventoryApiService.BASE_URL}/item/${itemId}/low-qty-alert`, {
      low_qty_alert_enabled: enabled,
      low_qty_alert_value: value,
    });
  }

  // ─── Tags ────────────────────────────────────────────────────────────────────

  getTags() {
    return Api.get(`${InventoryApiService.BASE_URL}/tags`);
  }

  syncTags(tags) {
    return Api.post(`${InventoryApiService.BASE_URL}/tags/sync`, { tags });
  }

  saveItemTags(itemId, tagIds) {
    return Api.put(`${InventoryApiService.BASE_URL}/item/${itemId}/tags`, {
      tag_ids: tagIds,
    });
  }
}

export default new InventoryApiService();
